// react
import React, { Component } from 'react';

// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Slick from 'react-slick';
import { connect } from 'react-redux';

class StroykaSlickBase extends Component {
    slickRef;

    constructor(props) {
        super(props);

        this.state = {
            preventClick: false,
            slidesToShow: this.getSlidesToShow(),
        };
    }

    componentDidMount() {
        if (!this.element) {
            return;
        }

        this.element.addEventListener('mousedown', this.onMousedown);
        this.createMedias();
    }

    componentDidUpdate(prevProps) {
        const { children: prevChildren } = prevProps;
        const { children: currChildren } = this.props;

        if (currChildren !== prevChildren) {
            // setTimeout(() => {
            //     this.setState({ activeSlides: this.getActiveSlides(this.getStartPosition()) });
            // }, 0);
        }

        const { responsive: prevResponsive } = prevProps;
        const { responsive: currResponsive } = this.props;

        if (currResponsive !== prevResponsive) {
            this.unsubscribeMedias();
            this.createMedias();
        }
    }

    componentWillUnmount() {
        this.unsubscribeMedias();

        if (!this.element) {
            return;
        }
        this.element.removeEventListener('mousedown', this.onMousedown);
    }

    getSlidesCount() {
        const { children } = this.props;

        return React.Children.toArray(children).length;
    }

    getStartPosition() {
        let { infinite } = this.props;

        infinite = infinite === true || infinite === undefined;

        const slidesToShow = this.getSlidesToShow();
        const slidesCount = this.getSlidesCount();

        if (!infinite) {
            return Math.max(0, slidesCount - slidesToShow);
        }

        return (Math.ceil(slidesCount / slidesToShow) - 1) * slidesToShow;
    }

    getActiveSlides(currentIndex) {
        const slidesToShow = this.getSlidesToShow();
        const activeSlides = [];
        const slidesCount = this.getSlidesCount();

        const firstSlide = Math.max(
            0,
            Math.min(
                slidesCount - slidesToShow,
                currentIndex,
            ),
        );
        const lastSlide = Math.min(
            slidesCount,
            firstSlide + slidesToShow,
        );

        for (let i = firstSlide; i < lastSlide; i += 1) {
            activeSlides.push(i);
        }

        return activeSlides;
    }

    getSlidesToShow() {
        const { responsive, slidesToShow } = this.props;

        let result = slidesToShow || 1;

        if (responsive) {
            responsive.forEach((options) => {
                const { matches } = matchMedia(`(max-width: ${options.breakpoint}px)`);

                if (matches && options.settings.slidesToShow) {
                    result = options.settings.slidesToShow;
                }
            });
        }

        return result;
    }

    unsubscribeMedias = () => { };

    originalSlickNext = () => { };

    originalSlickPrev = () => { };

    setRef = (ref) => {
        this.element = ref;
    };

    onMousedown = (event) => {
        const downX = event.screenX;
        const downY = event.screenY;

        const onMousemove = (moveEvent) => {
            const { preventClick } = this.state;

            if (preventClick) {
                return;
            }

            const distance = Math.sqrt(
                (Math.abs(downX - moveEvent.screenX) ** 2)
                + (Math.abs(downY - moveEvent.screenY) ** 2),
            );

            if (moveEvent.cancelable && distance > 3) {
                moveEvent.preventDefault();
            }

            if (distance > 15) {
                this.setState({ preventClick: true });
            }
        };
        const onMouseup = () => {
            this.setState({ preventClick: false });

            document.removeEventListener('mousemove', onMousemove);
            document.removeEventListener('mouseup', onMouseup);
        };

        document.addEventListener('mousemove', onMousemove);
        document.addEventListener('mouseup', onMouseup);
    };

    setSlickRef = (ref) => {
        const { forwardRef } = this.props;

        if (forwardRef) {
            forwardRef(ref);
        }

        if (ref && ref === this.slickRef) {
            this.originalSlickNext = ref.slickNext;
            this.originalSlickPrev = ref.slickPrev;

            // eslint-disable-next-line no-param-reassign
            ref.slickNext = this.slickNext;
            // eslint-disable-next-line no-param-reassign
            ref.slickPrev = this.slickPrev;
        }

        this.slickRef = ref;
    };

    createMedias() {
        const { responsive, slidesToShow } = this.props;

        if (responsive && responsive.length > 0) {
            const subscriptions = [];

            const createMedia = (query, slidesToShow) => {
                const media = matchMedia(query);

                const onChange = () => {
                    const { matches } = media;

                    if (matches && slidesToShow) {
                        this.setState(() => ({ slidesToShow }));
                    }
                };

                if (media.addEventListener) {
                    media.addEventListener('change', onChange);
                } else {
                    media.addListener(onChange);
                }

                subscriptions.push(() => {
                    if (media.removeEventListener) {
                        media.removeEventListener('change', onChange);
                    } else {
                        media.removeListener(onChange);
                    }
                });
            };

            createMedia(`(min-width: ${responsive[0].breakpoint}.02px)`, slidesToShow || 1);

            responsive.forEach((options, index) => {
                const query = [
                    `(max-width: ${options.breakpoint}px)`,
                ];

                if (responsive.length - 1 !== index) {
                    query.push(`(min-width: ${responsive[index + 1].breakpoint}.02px)`);
                }

                createMedia(query.join(' and '), options.settings.slidesToShow);
            });

            this.unsubscribeMedias = () => {
                subscriptions.forEach((x) => x());
            };
        }
    }

    render() {
        const {
            children,
            forwardRef,
            locale,
            beforeChange,
            ...otherProps
        } = this.props;
        const { preventClick, slidesToShow } = this.state;

        const classes = classNames('slick-prevent-click', {
            'slick-prevent-click--active': preventClick,
        });

        let reversedChildren = React.Children.toArray(children);

        reversedChildren = reversedChildren.map((slide, index) => {
            const slideClasses = classNames('correct-slick-active');

            return (
                <div key={index} className={slideClasses}>
                    {slide}
                </div>
            );
        });

        return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div
                className={classes}
                onMouseDown={this.onMousedown}
                ref={this.setRef}
            >
                <Slick
                    {...otherProps}
                    beforeChange={this.beforeChange}
                    infinite={otherProps.infinite && React.Children.count(children) > slidesToShow}
                    ref={this.setSlickRef}
                >
                    {reversedChildren}
                </Slick>
            </div>
        );
    }
}

StroykaSlickBase.propTypes = {
    locale: PropTypes.string,
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

const StroykaSlick = connect(mapStateToProps)(StroykaSlickBase);

export default React.forwardRef((props, ref) => (
    <StroykaSlick forwardRef={ref} {...props} />
));
